var View = require('views/base/view');

module.exports = View.extend({
	autoRender: true,
	container: '#header',
	template: require('./templates/header')
});